import { useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { toast } from 'sonner';

export default function FixFloristRole() {
  const { user, updateUserRole } = useAuth();

  useEffect(() => {
    const fixRole = async () => {
      if (!user) return;
      
      // Check if this is the specific user we want to fix
      if (user.id === '97be634d-d7b6-442b-a8b6-f9e3ff3582d9') {
        console.log('Fixing florist role for user:', user.id);
        await updateUserRole('florist');
      }
    };

    fixRole();
  }, [user, updateUserRole]);

  return null; // This component doesn't render anything
} 